<mat-toolbar matDialogTitle class="mat-accent m-0">
  <span class="title dialog-title">{{header | translate}}</span>
  <button mat-button class="mat-icon-button"
          (click)="dialogRef.close()"
          aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<mat-dialog-content class="content">
  <mat-form-field>
    <mat-label>{{'competency.title' | translate}}</mat-label>
    <input matInput [(ngModel)]="title" required #titleInput="ngModel"/>
    @if (titleInput.invalid && titleInput.touched) {
      <mat-error>{{'competency.title_required' | translate}}</mat-error>
    }
  </mat-form-field>
  @if (color()) {
    <div class="choose-color">
      <mat-label>{{'competency.choose_color' | translate}} *</mat-label>
      <fuse-material-color-picker (onValueChange)="onSettingsChange($event)"
      [userColor]="color()">
      </fuse-material-color-picker>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button class="mat-accent" [disabled]="isTitleEmpty()"
          (click)="onSaveClick()" >{{'main.save' | translate}}</button>
  <button mat-raised-button class="mat-accent" (click)="onNoClick()">{{'main.cancel' | translate}}</button>
</mat-dialog-actions>
